document.addEventListener("DOMContentLoaded", () => {
  const wrap = document.getElementById("variant-specs");
  const codeEl = document.getElementById("specs_code");
  const sizeEl = document.getElementById("specs_size");
  const absorptionEl = document.getElementById("specs_absorption");
  const quantityEl = document.getElementById("specs_quantity");

  const specsData = window.variantSpecsData || {};
  const initialId = window.initialVariantId;

  const normalize = (val) => (val == null ? "" : String(val).trim());

  function getCurrentVariantId() {
    const checked = document.querySelector('input[name="id"]:checked');
    if (checked?.value) return checked.value;

    const sel = document.querySelector('select[name="id"]');
    if (sel?.value) return sel.value;

    const hidden = document.querySelector('input[name="id"][type="hidden"]');
    if (hidden?.value) return hidden.value;

    return initialId;
  }

  function updateSpecs(variantId) {
    const id = variantId || getCurrentVariantId();
    const s = specsData[id];
    if (!s) {
      if (wrap) wrap.style.display = "none";
      return;
    }

    const code = normalize(s.code);
    const size = normalize(s.size);
    const absorption = normalize(s.absorption);
    const quantity = normalize(s.quantity);
    const unit = normalize(s.count);

    if (wrap) wrap.style.display = "";
    if (codeEl) codeEl.textContent = code ? code.split("(")[0].trim() : "—";
    if (codeEl) codeEl.title = code || "";
    if (sizeEl) sizeEl.textContent = size || "—";
    if (absorptionEl) absorptionEl.textContent = absorption || "—";

    // Combine quantity and unit count
    if (quantityEl) {
      if (quantity && unit) {
        quantityEl.textContent = `${quantity} (${unit})`; 
      } else {
        quantityEl.textContent = quantity || unit || "—";
      }
    }
  }

  function refresh() {
    updateSpecs(getCurrentVariantId());
  }

  document.addEventListener("change", (e) => {
    if (e.target.matches('input[name="id"], select[name="id"]')) refresh();
  });
  document.addEventListener("variant:change", (e) => updateSpecs(e?.detail?.variant?.id));
  document.addEventListener("variant:changed", (e) => updateSpecs(e?.detail?.variant?.id));
  document.addEventListener("shopify:section:load", refresh);

  refresh(); // initial load
});